import { gql, useMutation } from '@apollo/client';
import { generateChecksum } from 'helpers/generateChecksum';

const CREATE_DIRECT_UPLOAD = gql`
  mutation CreateDirectUpload($input: CreateDirectUploadInput!) {
    createDirectUpload(input: $input) {
      errors {
        error
        message
      }
      directUpload {
        blobId
        headers
        signedBlobId
        url
      }
    }
  }
`;

export default function useDirectUpload() {
  const [createDirectUploadMutation, { loading, error }] =
    useMutation(CREATE_DIRECT_UPLOAD);
  const createDirectUpload = async ({ file, className }) => {
    const checksum = await generateChecksum(file);
    return createDirectUploadMutation({
      variables: {
        input: {
          filename: file.name,
          byteSize: file.size,
          checksum,
          contentType: file.type,
          className,
        },
      },
    });
  };
  return {
    createDirectUpload,
    error,
    loading,
  };
}
